module.exports = __webpack_public_path__ + "images/blog/blog_card/questions/16_00b41ec92672e6004003ae7fd4c456ac.jpg";